export const SPOT_DELIVERY = 'spot_delivery';
